<template>
    <div>
        <h1 class="subtitle">Producto</h1>
        <div class="nj-card">
            <div class="nj-cols form c2 l-c3">
                <div>
                    <div class="nj-label">Nombre</div>
                    <input type="text" class="nj-text" v-model="filters.pvt_nombre" ref="pvt_nombre" @keyup.enter="buscar()">
                </div>
                <div>
                    <div class="nj-label">Estado</div>
                    <select class="nj-select" v-model="filters.est_id">
                        <option></option>
                        <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                    </select>
                </div>
            </div>
            <Buttons line>
                <button class="nj-button" @click="buscar()">Buscar</button>
                <button class="nj-button c-green" @click="abrirRegistrar()">Nuevo</button>
            </Buttons>
        </div>
        <br>
        <div class="nj-card">
            <b-table :data="productos_venta" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :pagination-position="paginationPosition" :default-sort-direction="defaultSortDirection" :pagination-rounded="isPaginationRounded" :sort-icon="sortIcon" :sort-icon-size="sortIconSize" aria-next-label="Next page"
                aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
                <template slot-scope="props">
                    <b-table-column label="Nombre" header-class="is-info">{{ props.row.pvt_nombre }}</b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-field>
                            <b-tag :class="tagEstado(props.row.est_id)">{{ props.row.est_nombre }}</b-tag>
                        </b-field>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <button class="nj-button icon c-blue" @click="abrirVer(props.row.pvt_id)" title="Ver"><i class="mdi-information"></i></button>
                            <button class="nj-button icon" @click="abrirModificar(props.row.pvt_id)" title="Modificar"><i class="mdi-pencil"></i></button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
        <!-- popups -->
        <RegistrarProductoVenta v-if="popupRegistrar" @close="cerrarRegistrar($event)" />
        <ModificarProductoVenta v-if="popupModificar" @close="cerrarModificar($event)" :pvt_id="pvt_id" />
        <VerProductoVenta v-if="popupVer" @close="cerrarVer()" :pvt_id="pvt_id" />
    </div>
</template>

<script>
import { AppService, ResponseStatus } from "../../rest"
import ProductoVentaService from "../../services/ProductoVentaService"
import Arrays from "../../util/arrays"
import Toast from "../../util/toast"
import { Buttons } from "../components"
import ModificarProductoVenta from "./ModificarProductoVenta.vue"
import RegistrarProductoVenta from "./RegistrarProductoVenta.vue"
import VerProductoVenta from "./VerProductoVenta.vue"

export default {
    name: "ProductoVenta",
    components: {
        ModificarProductoVenta,
        RegistrarProductoVenta,
        VerProductoVenta,
        Buttons,
    },
    data() {
        return {
            filters: {
                pvt_nombre: null,
                est_id: null,
            },
            productos_venta: [],
            estados: [],
            popupRegistrar: false,
            popupModificar: false,
            popupVer: false,
            pvt_id: null,
            isPaginated: true,
            isPaginationSimple: false,
            isPaginationRounded: false,
            paginationPosition: "bottom",
            defaultSortDirection: "asc",
            sortIcon: "arrow-up",
            sortIconSize: "is-small",
            currentPage: 1,
            perPage: 10,
        }
    },
    methods: {
        buscar() {
            ProductoVentaService.buscar({
                producto_venta: this.filters
            }).then(
                response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.productos_venta = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                },
                error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                }
            )
        },
        abrirRegistrar() {
            this.popupRegistrar = true
        },
        abrirVer(id) {
            this.pvt_id = id
            this.popupVer = true
        },
        abrirModificar(id) {
            this.pvt_id = id
            this.popupModificar = true
        },
        cerrarRegistrar(condition) {
            this.popupRegistrar = false
            if (condition) {
                this.buscar()
            }
        },
        cerrarVer() {
            this.popupVer = false
        },
        cerrarModificar(condition) {
            this.popupModificar = false
            if (condition) {
                this.buscar()
            }
        },
        cerrarPopups() {
            this.cerrarRegistrar(false)
            this.cerrarModificar(false)
        },
        tagEstado(id) {
            return this.estados.find((item) => item.est_id == id).styles
        }
    },
    mounted() {
        this.$refs.pvt_nombre.focus()
        AppService.getData(["estados"]).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.estados = Arrays.filter(response.data.estados, "est_codigo", ["activo", "inactivo"])
                    this.buscar()
                }
                else {
                    Toast.warn(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>